<template>
  
  <div v-if="visible" class="force-overlay">
    <div class="force-card">
      
      <template v-if="mode === 'update'">
        <div class="force-icon">📦</div>
        <h2 class="force-title">发现新版本</h2>
        <p class="force-msg">{{ message || '新版本已发布，请更新后使用' }}</p>
        <p class="force-version" v-if="latestVersion">最新版本: v{{ latestVersion }}</p>
        <button class="force-btn update-btn" @click="handleUpdate">立即更新</button>
      </template>

      
      <template v-else-if="mode === 'kicked'">
        <div class="force-icon">🔒</div>
        <h2 class="force-title">设备已下线</h2>
        <p class="force-msg">{{ message || '当前账号已在其他设备登录，本机需重新登录' }}</p>
        <button class="force-btn kicked-btn" @click="handleReactivate">知道了</button>
      </template>

      
      <template v-else>
        <div class="force-icon">⏰</div>
        <h2 class="force-title">登录已过期</h2>
        <p class="force-msg">请重新登录后使用</p>
        <button class="force-btn kicked-btn" @click="handleReactivate">去登录</button>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { Browser } from "@capacitor/browser";
const visible = ref(false);
const mode = ref("");
const message = ref("");
const updateUrl = ref("");
const latestVersion = ref("");
const showForceUpdate = (url, msg, version) => {
    mode.value = "update";
    updateUrl.value = url || "";
    message.value = msg || "";
    latestVersion.value = version || "";
    visible.value = true;
};
const showKicked = (msg) => {
    mode.value = "kicked";
    message.value = msg || "";
    visible.value = true;
};
const showExpired = () => {
    mode.value = "expired";
    visible.value = true;
};
const hide = () => {
    visible.value = false;
};
const emit = defineEmits(["reactivate"]);
const handleUpdate = async () => {
    if (updateUrl.value) {
        try {
            await Browser.open({ url: updateUrl.value });
        }
        catch (e) {
            window.open(updateUrl.value, "_blank");
        }
    }
};
const handleReactivate = () => {
    visible.value = false;
    emit("reactivate");
};
defineExpose({ showForceUpdate, showKicked, showExpired, hide });
</script>

<style scoped>
.force-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.force-card {
  background: #fff;
  border-radius: 16px;
  padding: 40px 30px;
  text-align: center;
  max-width: 320px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.force-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.force-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin: 0 0 12px;
}

.force-msg {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0 0 8px;
}

.force-version {
  font-size: 12px;
  color: #999;
  margin: 0 0 24px;
}

.force-btn {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 22px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
  margin-top: 16px;
}

.update-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.kicked-btn {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.force-btn:active {
  opacity: 0.85;
  transform: scale(0.98);
}
</style>
